import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Button, Card, Col, Form, Row, Modal } from "react-bootstrap";

import {
  updateDeliverableData,
  fetchDeliverables,
} from "../../../../store/features/deliverable/deliverableSlice";

// Validation schema
const validationSchema = Yup.object().shape({
  approvalStatus: Yup.boolean().required("accepted is required"),
  rejectionReason: Yup.string().when(
    "approvalStatus",
    (rejectionReason, schema) => {
      return rejectionReason === false
        ? schema.required("not AcceptedReason is required")
        : schema.notRequired();
    }
  ),
});

const AcceptedDeliverableFormModal = ({
  DeliverableInfoData,
  showAccepted,
  setShowAccepted,
}) => {
  const dispatch = useDispatch();

  const initialValues = {
    approvalStatus: true,
    rejectionReason: "",
    progressLevel: "",
  };

  const handleSubmit = async (values, { resetForm }) => {
    try {
      if (DeliverableInfoData._id) {
        const updateData = {
          ...DeliverableInfoData,
          approvalStatus: values.approvalStatus ? "Accepted" : "Not Accepted",
          rejectionReason: values.rejectionReason,
          progressLevel: +values.progressLevel,
          _id: DeliverableInfoData._id,
        };
        await dispatch(updateDeliverableData({ ...updateData })).unwrap();
        toast.success("Deliverable status updated successfully");
      }
      await dispatch(fetchDeliverables());
      setShowAccepted(false);
      resetForm();
    } catch (err) {
      toast.error("Error Deliverable status updated");
    }
  };

  const progessLevelsOptoins = [10, 30, 50, 80, 100];

  return (
    <Modal show={showAccepted} onHide={() => setShowAccepted(false)}>
      <Modal.Header closeButton>
        <Modal.Title>{DeliverableInfoData.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Card>
          <Card.Body>
            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({
                values,
                handleChange,
                handleSubmit,
                touched,
                errors,
                isSubmitting,
                resetForm,
                setFieldValue,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Check
                          name="approvalStatus"
                          type="switch"
                          label="Accepted/Not Accepted"
                          checked={values.approvalStatus}
                          onChange={(e) =>
                            setFieldValue("approvalStatus", e.target.checked)
                          }
                        />
                      </Form.Group>
                    </Col>
                    {!values.approvalStatus && (
                      <Col md={12}>
                        <Form.Control
                          type="text"
                          as="textarea"
                          name="rejectionReason"
                          value={values.rejectionReason}
                          onChange={handleChange}
                          isInvalid={
                            touched.rejectionReason && !!errors.rejectionReason
                          }
                          rows={3}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.rejectionReason}
                        </Form.Control.Feedback>
                      </Col>
                    )}
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Progess Level</Form.Label>
                        <Form.Select
                          name="progressLevel"
                          label="Progess level"
                          checked={values.progressLevel}
                          onChange={handleChange}
                        >
                          <option value="">Select</option>
                          {progessLevelsOptoins?.map((level) => (
                            <option key={level} value={level}>
                              {level}%
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mt-3">
                    <Col className="text-end">
                      <Button
                        variant="secondary"
                        onClick={() => {
                          resetForm();
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        className="ms-2"
                        variant="primary"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        Submit
                      </Button>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </Card.Body>
        </Card>
      </Modal.Body>
    </Modal>
  );
};

export default AcceptedDeliverableFormModal;
